// import { Link, useNavigate } from "react-router-dom";
// import React, { useState, useEffect } from "react";
// import { getToken, removeToken, getUser, removeUser } from "../../utils/auth";
// import axios from "axios";
// import { useTranslation } from "react-i18next";
// import { useCurrency } from "../../context/CurrencyContext";
// import CONFIG from "../../config";
// import { useBranding } from "../../context/BrandingContext";
// import BRANDING_FALLBACK from "../../branding";

// const Header = () => {
//   const { branding } = useBranding();
//   const BRANDING = branding || BRANDING_FALLBACK;
//   const { t, i18n } = useTranslation();
//   const { currency, setCurrency } = useCurrency();
//   const [isOpen, setIsOpen] = useState(false);
//   // const [user, setUserState] = useState(null);
//   const [isAdmin, setIsAdmin] = useState(false);
//   const navigate = useNavigate();

//   const isAr = i18n.language?.startsWith('ar');

//   const toggleLanguage = () => {
//     const nextLng = i18n.language === 'en' ? 'ar' : 'en';
//     i18n.changeLanguage(nextLng);
//   };

//   const [scrolled, setScrolled] = useState(false);

//   // const paddingStyle = { paddingTop: "100px" };

//   useEffect(() => {
//     let ticking = false;

//     const handleScroll = () => {
//       if (!ticking) {
//         window.requestAnimationFrame(() => {
//           setScrolled(window.scrollY > 20);
//           ticking = false;
//         });
//         ticking = true;
//       }
//     };

//     // Wait for page to be fully loaded to prevent "Layout was forced" warning
//     if (document.readyState === 'complete') {
//       window.addEventListener('scroll', handleScroll, { passive: true });
//     } else {
//       window.addEventListener('load', () => {
//         window.addEventListener('scroll', handleScroll, { passive: true });
//       });
//     }

//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   useEffect(() => {
//     const check = () => {
//       try {
//         const u = getUser();
//         // setUserState(u);
//         setIsAdmin(!!u?.isAdmin);
//       } catch (e) {
//         // setUserState(null);
//         setIsAdmin(false);
//       }
//     };

//     check();

//     // const onStorage = (e) => {
//     //   if (e.key === 'user') check();
//     // };

//     const onCustom = () => check();

//     // window.addEventListener('storage', onStorage);
//     window.addEventListener('user_changed', onCustom);
//     return () => {
//       // window.removeEventListener('storage', onStorage);
//       window.removeEventListener('user_changed', onCustom);
//     };
//   }, []);

//   // ✅ Logout function
//   const handleLogout = async () => {
//     try {
//       const token = getToken();
//       if (!token) return;

//       // Optional: if your backend uses a logout API
//       const currentUser = getUser();
//       await axios.post(
//         `${CONFIG.API_URL}/api/auth/logout`,
//         { userId: currentUser?.id },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       removeToken(); // Remove token locally
//       removeUser();
//       navigate("/login");
//     } catch (err) {
//       console.error("Logout failed:", err);
//     }
//   };

//   return (
//     <header
//       className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${scrolled ? "shadow-lg py-2" : "py-4 shadow-md"}`}
//       style={{
//         backgroundColor: scrolled ? 'var(--bg-header)' : 'var(--bg-header)',
//         color: 'var(--text-header)',
//         backdropFilter: scrolled ? 'blur(8px)' : 'none'
//       }}
//     >
//       <nav className="max-w-7xl mx-auto px-6 flex justify-between items-center transition-all duration-300">

//         {/* Logo */}
//         <Link to="/" className="flex items-center group">
//           {BRANDING.logo.path ? (
//             <img
//               src={BRANDING.logo.path ? BRANDING.logo.path : "/logo.png"}
//               alt={BRANDING.logo.alt}
//               className={`transition-all duration-300 object-contain ${scrolled ? "h-10 md:h-12 lg:h-14" : "h-14 md:h-16 lg:h-20"
//                 } group-hover:scale-105`}
//             />
//           ) : (
//             <span className="text-2xl font-bold text-brand-text-header">
//               {isAr ? (
//                 <>{BRANDING.appName.ar.split(' ')[0]}<span className="text-brand-primary"> {BRANDING.appName.ar.split(' ').slice(1).join(' ')}</span></>
//               ) : (
//                 <>{BRANDING.appName.en.split(' ').slice(0, -1).join(' ')} <span className="text-brand-primary">{BRANDING.appName.en.split(' ').slice(-1)}</span></>
//               )}
//             </span>
//           )}
//         </Link>

//         {/* Mobile Toggle */}
//         <button
//           className="lg:hidden p-2 zz transition-colors"
//           style={{ color: 'var(--text-header)' }}
//           onClick={() => setIsOpen(!isOpen)}
//         >
//           <span className="text-2xl">{isOpen ? "✕" : "☰"}</span>
//         </button>

//         {/* Links */}
//         <ul
//           className={`lg:flex lg:items-center gap-4 xl:gap-6 absolute lg:static w-full lg:w-auto left-0 transition-all duration-300 ${isOpen
//             ? (scrolled ? "top-16 p-6 shadow-xl border-b" : "top-20 p-6 shadow-xl border-b")
//             : "top-[-500px]"
//             }`}
//           style={{ backgroundColor: 'var(--bg-header)' }}
//         >
//           {/* Main Navigation */}
//           {[
//             { to: "/", label: t('header.home') },
//             { to: "/shop", label: t('header.shop') },
//             BRANDING.features?.comparison && { to: "/compare", label: t('header.compare') },
//             { to: "/about", label: t('header.about') },
//             { to: "/contact", label: t('header.contact') },
//           ].filter(Boolean).map(l => (
//             <li key={l.to} className="w-full lg:w-auto">
//               <Link
//                 to={l.to}
//                 onClick={() => setIsOpen(false)}
//                 className="hover:text-brand-primary block py-2 lg:py-0 font-medium transition-colors whitespace-nowrap zz"
//               >
//                 {l.label}
//               </Link>
//             </li>
//           ))}

//           {/* Switchers Group */}
//           <li className="flex items-center gap-2 py-2 lg:py-0 border-t lg:border-t-0 mt-2 lg:mt-0 pt-4 lg:pt-0">
//             {/* Language Switcher */}
//             <button
//               onClick={toggleLanguage}
//               className="flex-1 lg:flex-none px-3 py-1.5 border border-gray-200 rounded-full hover:bg-gray-50 font-medium text-xs transition-colors bg-white shadow-sm flex items-center justify-center gap-1.5 min-w-[90px]"
//               title={i18n.language === 'en' ? 'Switch to Arabic' : 'التبديل إلى الإنجليزية'}
//             >
//               <span className="text-gray-400">🌐</span>
//               {i18n.language === 'en' ? 'العربية' : 'English'}
//             </button>

//             {/* Currency Switcher */}
//             <div className="relative flex-1 lg:flex-none">
//               <select
//                 value={currency}
//                 onChange={(e) => setCurrency(e.target.value)}
//                 className={isAr
//                   ? "w-full lg:w-auto appearance-none pl-3 pr-4 lg:pl-8 lg:pr-4 py-1.5 border border-gray-200 rounded-full hover:bg-gray-50 font-medium text-xs transition-colors bg-white shadow-sm cursor-pointer focus:outline-none focus:ring-2 focus:ring-brand-primary/20"
//                   : "w-full lg:w-auto appearance-none pl-3 pr-8 py-1.5 border border-gray-200 rounded-full hover:bg-gray-50 font-medium text-xs transition-colors bg-white shadow-sm cursor-pointer focus:outline-none focus:ring-2 focus:ring-brand-primary/20"
//                 }>
//                 <option value="USD">USD</option>
//                 <option value="EGP">EGP</option>
//                 <option value="SDG">SDG</option>
//               </select>
//               <div className={isAr
//                 ? "absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none text-[10px] text-gray-400"
//                 : "absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-[10px] text-gray-400"
//               }>
//                 ▼
//               </div>
//             </div>
//           </li>

//           {/* E-commerce Icons */}
//           {(BRANDING.features?.cart || BRANDING.features?.wishlist) && (
//             <li className="flex items-center gap-4 py-2 lg:py-0 border-t lg:border-t-0 mt-2 lg:mt-0 pt-4 lg:pt-0 border-gray-100 px-2">
//               {BRANDING.features?.wishlist && (
//                 <Link to="/wishlist" className="relative group p-1" onClick={() => setIsOpen(false)} title={t('header.wishlist')}>
//                   <span className="text-xl transition-transform group-hover:scale-110 inline-block">❤️</span>
//                 </Link>
//               )}
//               {BRANDING.features?.cart && (
//                 <Link to="/cart" className="relative group p-1" onClick={() => setIsOpen(false)} title={t('header.cart')}>
//                   <span className="text-xl transition-transform group-hover:scale-110 inline-block">🛒</span>
//                 </Link>
//               )}
//             </li>
//           )}

//           {/* CTA & Admin Section */}
//           <li className="flex flex-col lg:flex-row items-stretch lg:items-center gap-3 mt-2 lg:mt-0 border-t lg:border-t-0 pt-4 lg:pt-0">
//             {/* CTA Button */}
//             <a
//               href={`tel:${BRANDING.contact.phoneHeader}`}
//               className={`flex ${isAr ? "flex-reverse" : ""} items-center justify-center gap-2 bg-brand-primary text-white px-5 py-2 rounded-full hover:bg-brand-primary-hover transition-all shadow-md hover:shadow-lg active:scale-95 font-medium text-sm whitespace-nowrap`}
//             >
//               <span className="text-base">📞</span>
//               {t('header.call_us')}
//             </a>

//             {/* Auth & Admin Section */}
//             <div className="flex flex-col lg:flex-row items-stretch lg:items-center gap-2">
//               {BRANDING.features?.userPortal && (
//                 <Link
//                   to="/profile"
//                   className="px-4 py-2 text-gray-700 hover:text-brand-primary zz font-bold text-sm transition-colors text-center flex items-center justify-center gap-1"
//                   onClick={() => setIsOpen(false)}
//                 >
//                   👤 {t('header.profile')}
//                 </Link>
//               )}

//               {isAdmin && (
//                 <>
//                   <Link
//                     to="/admin"
//                     className="flex-1 lg:flex-none flex items-center justify-center gap-1 px-4 py-2 text-gray-700 hover:text-brand-primary zz font-bold transition-colors whitespace-nowrap text-sm border-l lg:border-l-2 border-gray-100 ml-0 lg:ml-2"
//                     onClick={() => setIsOpen(false)}
//                   >
//                     ⚙️ {t('header.admin')}
//                   </Link>
//                   {/* <Link
//                     to="/admin/contracts"
//                     className="flex-1 lg:flex-none flex items-center justify-center gap-1 px-4 py-2 text-gray-700 hover:text-brand-primary zz font-bold transition-colors whitespace-nowrap text-sm"
//                     onClick={() => setIsOpen(false)}
//                     title="Manage Contracts"
//                   >
//                     📋 {t('header.contracts', 'Contracts')}
//                   </Link> */}
//                 </>
//               )}

//               {getUser() && (
//                 <button
//                   onClick={() => { handleLogout(); setIsOpen(false); }}
//                   className="flex items-center justify-center gap-2 px-4 py-2 text-red-500 hover:bg-red-50 rounded-full transition-colors font-bold text-sm"
//                   title={t('header.logout')}
//                 >
//                   <span className="lg:hidden">{t('header.logout')}</span>
//                   <span className="hidden lg:block">🚪</span>
//                 </button>
//               )}

//               {!getUser() && (
//                 <Link
//                   to="/login"
//                   className="px-4 py-2 bg-gray-100 text-gray-700 hover:bg-brand-primary hover:text-white rounded-full font-bold text-sm transition-all text-center"
//                   onClick={() => setIsOpen(false)}
//                 >
//                   {t('header.login')}
//                 </Link>
//               )}
//             </div>
//           </li>
//         </ul>
//       </nav>
//     </header >
//   );
// };

// export default Header;









// ======================================
// New work isMaster
// ======================================
import { Link, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { getToken, removeToken, getUser, removeUser } from "../../utils/auth";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { useCurrency } from "../../context/CurrencyContext";
import CONFIG from "../../config";
import { useBranding } from "../../context/BrandingContext";
import BRANDING_FALLBACK from "../../branding";

const Header = () => {
  const { branding } = useBranding();
  const BRANDING = branding || BRANDING_FALLBACK;
  const { t, i18n } = useTranslation();
  const { currency, setCurrency } = useCurrency();
  const [isOpen, setIsOpen] = useState(false);
  // const [user, setUserState] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isMaster, setIsMaster] = useState(false);
  const navigate = useNavigate();

  const isAr = i18n.language?.startsWith('ar');

  const toggleLanguage = () => {
    const nextLng = i18n.language === 'en' ? 'ar' : 'en';
    i18n.changeLanguage(nextLng);
  };

  const [scrolled, setScrolled] = useState(false);

  // const paddingStyle = { paddingTop: "100px" };

  useEffect(() => {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setScrolled(window.scrollY > 20);
          ticking = false;
        });
        ticking = true;
      }
    };

    // Wait for page to be fully loaded to prevent "Layout was forced" warning
    if (document.readyState === 'complete') {
      window.addEventListener('scroll', handleScroll, { passive: true });
    } else {
      window.addEventListener('load', () => {
        window.addEventListener('scroll', handleScroll, { passive: true });
      });
    }

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const MASTER_PROFILE_ID = 'prof_01JK0000000000000000000001';

    const checkAll = () => {
      try {
        const u = getUser();
        setIsAdmin(!!u?.isAdmin);

        // Derive isMaster from stored permissions + profile_id
        // (same logic as the server's isTrueMaster helper)
        const perms = u?.permissions || [];
        const hasStar = Array.isArray(perms)
          ? perms.includes('*')
          : (typeof perms === 'string' && (perms === '*' || perms.includes('*')));
        setIsMaster(hasStar && (!u?.profile_id || u?.profile_id === MASTER_PROFILE_ID));
      } catch (e) {
        setIsAdmin(false);
        setIsMaster(false);
      }
    };

    checkAll();

    window.addEventListener('user_changed', checkAll);
    return () => {
      window.removeEventListener('user_changed', checkAll);
    };
  }, []);

  // ✅ Logout function
  const handleLogout = async () => {
    try {
      const token = getToken();
      if (!token) return;

      // Optional: if your backend uses a logout API
      const currentUser = getUser();
      await axios.post(
        `${CONFIG.API_URL}/api/auth/logout`,
        { userId: currentUser?.id },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      removeToken(); // Remove token locally
      removeUser();
      navigate("/login");
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${scrolled ? "shadow-lg py-2" : "py-4 shadow-md"}`}
      style={{
        backgroundColor: scrolled ? 'var(--bg-header)' : 'var(--bg-header)',
        color: 'var(--text-header)',
        backdropFilter: scrolled ? 'blur(8px)' : 'none'
      }}
    >
      <nav className="max-w-7xl mx-auto px-6 flex justify-between items-center transition-all duration-300">

        {/* Logo */}
        <Link to="/" className="flex items-center group">
          {BRANDING.logo.path ? (
            <img
              src={BRANDING.logo.path ? BRANDING.logo.path : "/logo.png"}
              alt={BRANDING.logo.alt}
              className={`transition-all duration-300 object-contain ${scrolled ? "h-10 md:h-12 lg:h-14" : "h-14 md:h-16 lg:h-20"
                } group-hover:scale-105`}
            />
          ) : (
            <span className={`text-2xl font-bold text-brand-text-header flex items-center ${scrolled ? "h-12 md:h-14 lg:h-16" : "h-14 md:h-16 lg:h-20"
              }`}>
              {isAr ? (
                <>{BRANDING.appName.ar.split(' ')[0]}<span className="text-brand-primary"> {BRANDING.appName.ar.split(' ').slice(1).join(' ')}</span></>
              ) : (
                <>{BRANDING.appName.en.split(' ').slice(0, -1).join(' ')} <span className="text-brand-primary">{BRANDING.appName.en.split(' ').slice(-1)}</span></>
              )}
            </span>
          )}
        </Link>

        {/* Mobile Toggle */}
        <button
          className="lg:hidden p-2 zz transition-colors"
          style={{ color: 'var(--text-header)' }}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className="text-2xl">{isOpen ? "✕" : "☰"}</span>
        </button>

        {/* Links */}
        <ul
          className={`lg:flex lg:items-center gap-4 xl:gap-6 absolute lg:static w-full lg:w-auto left-0 transition-all duration-300 ${isOpen
            ? (scrolled ? "top-16 p-6 shadow-xl border-b" : "top-20 p-6 shadow-xl border-b")
            : (!scrolled && "top-[-570px]")
            }`}
          style={{ backgroundColor: 'var(--bg-header)' }}
        >
          {/* Main Navigation */}
          {[
            { to: "/", label: t('header.home') },
            { to: "/shop", label: t('header.shop') },
            BRANDING.features?.comparison && { to: "/compare", label: t('header.compare') },
            { to: "/about", label: t('header.about') },
            { to: "/contact", label: t('header.contact') },
          ].filter(Boolean).map(l => (
            <li key={l.to} className="w-full lg:w-auto">
              <Link
                to={l.to}
                onClick={() => setIsOpen(false)}
                className="hover:text-brand-primary block py-2 lg:py-0 font-medium transition-colors whitespace-nowrap zz"
              >
                {l.label}
              </Link>
            </li>
          ))}

          {/* Switchers Group */}
          <li className="flex items-center gap-2 py-2 lg:py-0 border-t lg:border-t-0 mt-2 lg:mt-0 pt-4 lg:pt-0">
            {/* Language Switcher */}
            <button
              onClick={toggleLanguage}
              className="flex-1 lg:flex-none px-3 py-1.5 border border-gray-200 rounded-full hover:bg-gray-50 font-medium text-xs transition-colors bg-white shadow-sm flex items-center justify-center gap-1.5 min-w-[90px]"
              title={i18n.language === 'en' ? 'Switch to Arabic' : 'التبديل إلى الإنجليزية'}
            >
              <span className="text-gray-400">🌐</span>
              {i18n.language === 'en' ? 'العربية' : 'English'}
            </button>

            {/* Currency Switcher */}
            <div className="relative flex-1 lg:flex-none">
              <select
                value={currency}
                onChange={(e) => setCurrency(e.target.value)}
                className={isAr
                  ? "w-full lg:w-auto appearance-none pl-3 pr-4 lg:pl-8 lg:pr-4 py-1.5 border border-gray-200 rounded-full hover:bg-gray-50 font-medium text-xs transition-colors bg-white shadow-sm cursor-pointer focus:outline-none focus:ring-2 focus:ring-brand-primary/20"
                  : "w-full lg:w-auto appearance-none pl-3 pr-8 py-1.5 border border-gray-200 rounded-full hover:bg-gray-50 font-medium text-xs transition-colors bg-white shadow-sm cursor-pointer focus:outline-none focus:ring-2 focus:ring-brand-primary/20"
                }>
                <option value="USD">USD</option>
                <option value="EGP">EGP</option>
                <option value="SDG">SDG</option>
              </select>
              <div className={isAr
                ? "absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none text-[10px] text-gray-400"
                : "absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-[10px] text-gray-400"
              }>
                ▼
              </div>
            </div>
          </li>

          {/* E-commerce Icons */}
          {(BRANDING.features?.cart || BRANDING.features?.wishlist) && (
            <li className="flex items-center gap-4 py-2 lg:py-0 border-t lg:border-t-0 mt-2 lg:mt-0 pt-4 lg:pt-0 border-gray-100 px-2">
              {BRANDING.features?.wishlist && (
                <Link to="/wishlist" className="relative group p-1" onClick={() => setIsOpen(false)} title={t('header.wishlist')}>
                  <span className="text-xl transition-transform group-hover:scale-110 inline-block">❤️</span>
                </Link>
              )}
              {BRANDING.features?.cart && (
                <Link to="/cart" className="relative group p-1" onClick={() => setIsOpen(false)} title={t('header.cart')}>
                  <span className="text-xl transition-transform group-hover:scale-110 inline-block">🛒</span>
                </Link>
              )}
            </li>
          )}

          {/* CTA & Admin Section */}
          <li className="flex flex-col lg:flex-row items-stretch lg:items-center gap-3 mt-2 lg:mt-0 border-t lg:border-t-0 pt-4 lg:pt-0">
            {/* CTA Button */}
            <a
              href={`tel:${BRANDING.contact.phoneHeader}`}
              className={`flex ${isAr ? "flex-reverse" : ""} items-center justify-center gap-2 bg-brand-primary text-white px-5 py-2 rounded-full hover:bg-brand-primary-hover transition-all shadow-md hover:shadow-lg active:scale-95 font-medium text-sm whitespace-nowrap`}
            >
              <span className="text-base">📞</span>
              {t('header.call_us')}
            </a>

            {/* Auth & Admin Section */}
            <div className="flex flex-col lg:flex-row items-stretch lg:items-center gap-2">
              {getUser() && (
                BRANDING.features?.userPortal && (
                  <Link
                    to="/profile"
                    className="px-4 py-2 text-gray-700 hover:text-brand-primary zz font-bold text-sm transition-colors text-center flex items-center justify-center gap-1"
                    onClick={() => setIsOpen(false)}
                  >
                    👤 {t('header.profile')}
                  </Link>
                ))
              }

              {isAdmin && (
                <Link
                  to="/admin"
                  className={`flex-1 lg:flex-none flex items-center justify-center gap-1 px-4 py-2 text-gray-700 hover:text-brand-primary zz font-bold transition-colors whitespace-nowrap text-sm ${isAr ? "border-r lg:border-r-2 mr-0 lg:mr-2" : "border-l lg:border-l-2 ml-0 lg:ml-2"} border-gray-100`}
                  onClick={() => setIsOpen(false)}
                >
                  ⚙️ {t('header.admin')}
                </Link>
              )}
              {isMaster && (
                <Link
                  to="/admin/contracts"
                  className="flex-1 lg:flex-none flex items-center justify-center gap-1 px-4 py-2 text-gray-700 hover:text-brand-primary zz font-bold transition-colors whitespace-nowrap text-sm"
                  onClick={() => setIsOpen(false)}
                  title="Manage Contracts"
                >
                  📋 {t('header.contracts', 'Contracts')}
                </Link>
              )}

              {getUser() && (
                <button
                  onClick={() => { handleLogout(); setIsOpen(false); }}
                  className="flex items-center justify-center gap-2 px-4 py-2 text-red-500 hover:bg-red-50 rounded-full transition-colors font-bold text-sm"
                  title={t('header.logout')}
                >
                  <span className="lg:hidden">{t('header.logout')}</span>
                  <span className="hidden lg:block">🚪</span>
                </button>
              )}

              {!getUser() && (
                <>
                  <Link
                    to="/login"
                    className="px-4 py-2 bg-gray-100 text-gray-700 hover:bg-brand-primary hover:text-white rounded-full font-bold text-sm transition-all text-center"
                    onClick={() => setIsOpen(false)}
                  >
                    {t('header.login')}
                  </Link>
                  <Link
                    to="/signup"
                    className="px-4 py-2 bg-gray-100 text-gray-700 hover:bg-brand-primary hover:text-white rounded-full font-bold text-sm transition-all text-center"
                    onClick={() => setIsOpen(false)}
                  >
                    {t('header.signup')}
                  </Link>
                </>
              )}
            </div>
          </li>
        </ul>
      </nav>
    </header >
  );
};

export default Header;
